// CacheKey f4d112a247fce41efea3b91fcff55056
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-DICTIONARY_TEST_PROVIDER": {
    data_view: {
      default_name: {
        patients_search: "Members Search"
      },
      headers: {
        defaults: {
          encounter: {
            encounter_id: "Episode ID"
          }
        },
        workflows_view: {
          patient: {
            name: "Member"
          }
        }
      }
    }
  }
}

